<template>
  <div class="bg_gray">
    <Header navTitle="确认商品信息" navPath=""></Header>
    <div class="items_wrap">
      <van-cell-group v-if="order_goods_list.length > 0" v-for="(item,index) in order_goods_list" :key="index">
        <van-cell>
          <template #title>
            <!-- 课程 -->
            <div class="course_item_common" v-if="item.type == 'curriculum'">
              <div class="cover" @click="goCurDetail(item.cur_uuid)">
                <img :src="item.cur_cover" />
                <span class="hot" v-if="item.cur_label && item.cur_label != 'null'">{{item.cur_label}}</span>
                <span class="tag" v-if="item.cur_type">{{ item.cur_type }}</span>
              </div>
              <div class="content">
                <h4 @click="goCurDetail(item.cur_uuid)" class="text_ellipsis">{{ item.cur_name }}</h4>
                <div class="info">
                  <span>¥ {{ item.price }}</span>
                  课时：{{ item.chapter_desc }}
                </div>
              </div>
            </div>
            <!-- 会员卡 -->
            <div v-if="item.type == 'vip'">
              <VipCard :vip_card="item.goods_info"
                       :expired_at="item.goods_info.expired_detail_text"
                       :price_visible="false" :btn_buy="false" :btn_detail="false"></VipCard>
            </div>
          </template>
        </van-cell>
        <van-cell is-link @click="showDiscountModal(item)" v-if="item.type == 'curriculum'">
          <template #title>
            <div class="coupons_select">
              <div class="title">优惠</div>
              <div v-if="item.promotes_count > 0" class="info">
                <div v-if="item.promotes.length > 0">
                  <div>{{item.discount_desc}}</div>
                  <div v-if="item.expired_days">学习有效期：{{item.expired_days}}天</div>
                </div>
                <div v-else>
                  <div>选择可用优惠</div>
                </div>
              </div>
            </div>
          </template>
          <template #value>
            <div v-if="item.promotes_count > 0">
              <div v-if="item.promotes.length > 0">
                 <div style="color:#f51c21;">-¥{{ item.discount_amount }}</div>
              </div>
            </div>
          </template>
        </van-cell>
        <van-cell>
          <template #value>
            <div class="text-right"><span style="font-size:12px;color:#999;">实付：</span><span style="color:#f51c21;font-size:14px;">¥ {{ item.amount }}</span></div>
          </template>
        </van-cell>
      </van-cell-group>
      <!-- 总结 -->
      <div class="tip">共 {{ order_goods_list.length }} 个商品</div>
      <van-cell-group>
        <van-cell title="商品金额">
          <template #value>
            <div style="color:#666;">¥ {{total_amount}}</div>
          </template>
        </van-cell>
        <van-cell title="优惠金额">
          <template #value>
            <div style="color:#666;" v-if="discount_amount > 0">-¥{{discount_amount}}</div>
            <div style="color:#666;" v-else>-</div>
          </template>
        </van-cell>
      </van-cell-group>
      <!-- 总价 -->
      <div class="sheet_fixed_bottom_common">
        实付金额：<span><span>¥</span>{{order_amount}}</span>
        <van-button type="danger"
                    :disabled="submit_order_process"
                    :loading="submit_order_process"
                    @click="submitOrder" round
                    v-if="order_goods_list.length > 0">
          <span v-if="order_amount > 0">提交订单</span>
          <span v-else>完成订单</span>
        </van-button>
      </div>
    </div>
    <!-- 选择优惠券 -->
    <BottomSlideSheet v-model:isShow="discountModal.visible">
      <template #content>
        <div class="model_wrap">
          <!-- 兑换码 -->
          <van-cell-group inset class="code_input">
            <van-form ref="couponsExchangeFrm">
              <van-field
                v-model="discountModal.codeForm.exchangeCode"
                required
                center
                label="兑换码"
                label-width="60"
                placeholder="请输入优惠券兑换码"
                :rules="rules.exchangeCode">
                <template #button>
                  <van-button size="small" type="primary" @click="exchangeCouponsUser">领取</van-button>
                </template>
              </van-field>
            </van-form>
          </van-cell-group>
          <!-- tab -->
          <van-tabs v-model:active="discountModal.tabActiveName" color="#009dd9" title-active-color="#00ADEF" line-width="60" class="tab_common" ref="couponsTab">
            <van-tab title="可用" name="able"></van-tab>
            <van-tab title="不可用" name="disable"></van-tab>
          </van-tabs>
          <!-- 折扣 -->
          <div class="scroll_wrap" :style="{'height': scrollWrapHeight + 'px'}">
            <h4 class="modal_title">会员卡</h4>
            <van-radio-group v-model="discountModal.radio">
              <div class="discount_item" v-for="vip_card in discountModal.vip_users">
                <div class="radio">
                  <van-radio
                    :name="`vip#${vip_card.promotes_uuid}`"
                    :disabled="discountModal.tabActiveName=='disable'"
                    @click="notifyPromotesRadioChange(vip_card)"></van-radio>
                </div>
                <div class="discount">
                  <VipCard :vip_card="vip_card"
                     :expired_text_color="vip_card.expired_text_color"
                     :price_visible="false"
                     :btn_buy="false"
                     :btn_detail="false" :size_small="true"
                     :expired_at="vip_card.expired_at"></VipCard>
                  <div style="margin-top: 10px"
                       v-if="discountModal.tabActiveName=='disable'">
                    <span>不可用原因:  {{vip_card.disabled_reason}}</span>
                  </div>
                  <van-row :gutter="10" v-if="discountModal.tabActiveName=='able'" style="margin-top: 10px;">
                    <van-col :span="10">优惠金额：<span style="color: rgb(245, 28, 33);">¥ {{vip_card.discount_amount}}</span></van-col>
                    <van-col v-if="vip_card.type == 'free'" :span="14">学习有效期：{{vip_card.expired_days}} 天</van-col>
                    <van-col v-else :span="14"></van-col>
                  </van-row>
                </div>
              </div>
            </van-radio-group>
            <h4 class="modal_title">优惠券</h4>
            <van-radio-group v-model="discountModal.radio">
              <div class="discount_item" v-for="coupons in discountModal.coupons_users">
                <div class="radio">
                  <van-radio
                    :name="`coupons#${coupons.promotes_uuid}`"
                    :disabled="discountModal.tabActiveName=='disable'"
                    @click="notifyPromotesRadioChange(coupons)"></van-radio>
                </div>
                <div class="discount">
                  <Coupons :coupons="coupons"
                   :expired_text_color="coupons.expired_text_color"
                   :btn_issue="false"
                   :user_limit_visible="false"
                   :btn_detail="false" :size_small="true"
                   :expired_at="coupons.expired_at"></Coupons>
                  <div style="margin-top: 10px"
                       v-if="discountModal.tabActiveName=='disable'">
                    <span>不可用原因:  {{coupons.disabled_reason}}</span>
                  </div>
                  <van-row v-if="discountModal.tabActiveName=='able'" style="margin-top: 10px;">
                    <van-col>优惠金额：<span style="color: rgb(245, 28, 33);">¥ {{coupons.discount_amount}}</span></van-col>
                  </van-row>
                </div>
              </div>
            </van-radio-group>
          </div>
          <!-- buttons -->
          <div class="btns">
            <van-button type="danger" round block @click="confirmCurrentPromotes">确定</van-button>
            <van-button type="default" round block @click="clearDiscount">不使用优惠</van-button>
          </div>

        </div>

      </template>
    </BottomSlideSheet>
  </div>

  <van-overlay :show="submit_order_process" >
    <van-loading size="24px" vertical
                 style="display: flex; align-items: center;justify-content: center;height: 100%;">
      正在提交订单, 请稍后 ...
    </van-loading>
  </van-overlay>

</template>

<script>
  import Header from 'components/mobile/common/Header'
  import BottomSlideSheet from 'components/mobile/common/BottomSlideSheet'
  import VipCard from "components/mobile/settlement/VipCard"
  import Coupons from "components/mobile/settlement/Coupons"
  import { scrollToTop } from "utils/mobile/common"
  import {fmtVIPCardInfo} from 'api/settlement/vip_card/admin'
  import {fmtCouponsInfo} from 'api/settlement/coupons/admin'
  import {exchangeCoupons } from 'api/settlement/coupons/user'
  import {confirmOrder, listPromotes, submitOrder, confirmListPromotes} from 'api/settlement/order/user'
  import { selectBestDiscount, get_goods_discount_amount } from 'api/settlement/order/discount'
  import {fmtCartItemInfo} from 'api/settlement/cart/user'
  import {expired_delta_days_conf} from 'api/settlement/card_util'
  import { db_time_to_local_fmt, delta_days_text } from 'utils/timeutils'
  import { getCookie } from 'api/base/axios'
  import { toRefs } from 'vue'
  import { ElLoading,ElMessage } from 'element-plus';
  import { showMessage } from 'api/base/message'
  export default {
    components: {
      Header,
      BottomSlideSheet,
      VipCard,
      Coupons
    },
    data() {
      return {
        scrollWrapHeight: 0,
        best_discount_loading: false,
        submit_order_process: false,
        confirm_key: null,
        isShow: false,
        order_goods_list: [],
        total_amount: 0,
        discount_amount: 0,
        order_amount: 0,
        discountModal: {
          loading: false,
          visible: false,
          res_type: 'curriculum',
          res_uuid: null,
          tabActiveName: 'able',
          codeForm: {
            exchangeCode: ''
          },
          radio: '',
          noDiscount: true,
          current_goods_price: 0,
          current_promotes: null,
          ref_row: {
              discount_amount: null
          },
          vip_users: [],
          coupons_users: [],
        },
        rules: {
          exchangeCode: [
            {required: true, message: '优惠券兑换码不能为空', trigger: 'onChange'},
            {required: true, validator: (value, rule) =>{

              if (12 <= value.length && value.length <= 20) {
                return true;
              } else {
                return false;
              }

            }, message: '长度在 12~20 个字符内', trigger: 'onChange'},
          ],
        }
      }
    },
    created() {
      if (this.$route.params.confirm_key != undefined) {
        this.confirm_key = this.$route.params.confirm_key;
        this.loadConfirmOrderData();
      }

      this.$watch(() => this.discountModal.radio, (newVal, oldVal) => {

          if (newVal !== '') {

            this.discountModal.noDiscount = false;

          } else {

            this.discountModal.noDiscount = true;
          }

      });

      this.$watch(() => this.discountModal.tabActiveName, (newVal, oldVal) => {

          this.loadCurPromotes(this.discountModal.res_uuid);

      });

      this.$watch(() => this.discountModal.ref_row.discount_amount, (newVal, oldVal) => {
          this.notifyGoodsDiscouontTotal();
          this.discountModal.ref_row.amount = parseFloat((
              this.discountModal.ref_row.price - this.discountModal.ref_row.discount_amount).toFixed(2));
      });

      this.$watch(() => this.discountModal.visible, (newVal, oldVal) => {
        if (!newVal) {
          this.$refs.couponsExchangeFrm.resetValidation();
        } else {
          this.$refs.couponsTab.resize();
        }
      });


    },
    mounted() {
      this.$emit('update:isShowHeader', false);
      this.scrollWrapHeight = document.documentElement.clientHeight - 215
      this.$nextTick(()=>{
         scrollToTop()
      })
    },
    methods: {
      async loadConfirmOrderData(){

          const that = this;

          this.$emit('update:isShowOverlay', true);

          await confirmOrder(this.confirm_key).then(result=>{

            if (result.succeed) {

                let goods_list = [];

                let total_amount = 0;

                let have_goods_promotes = false;

                result.order_goods.forEach(item=>{

                    let filled_item = fmtCartItemInfo(item);
                    filled_item.promotes = [];
                    filled_item.discount_desc = '';
                    filled_item.discount_amount = 0;
                    filled_item.amount = filled_item.price;

                    goods_list.push(filled_item);

                    total_amount += filled_item.price;

                    if(item.type === "curriculum" && item.promotes_count > 0){
                        have_goods_promotes = true;
                    }

                });

                total_amount = parseFloat(total_amount.toFixed(2));

                that.order_goods_list = goods_list;
                that.total_amount = total_amount;
                that.order_amount = total_amount;

                // 如果商品中有课程,加载所有可用优惠,匹配最优解
                if (have_goods_promotes){
                  that.best_discount_loading = true;
                  var request_begin = new Date().getTime();
                  console.debug('[Request] Loading all promotes start ...');
                  confirmListPromotes(this.confirm_key).then(promotes_result => {

                      var request_end = new Date().getTime();
                      console.debug(`[Request] Loading all promotes ended, pending ${request_end - request_begin} ms`);

                    if (promotes_result.succeed) {

                        promotes_result.order_goods.forEach((item, index)=>{
                            item.goods_info = result.order_goods[index].goods_info;
                        });

                        let best_discount_dict = selectBestDiscount(promotes_result.order_goods);

                        console.log(best_discount_dict);

                        var match_end = new Date().getTime();
                        console.debug(`[Total] in ${match_end - request_begin} ms`);

                        that.order_goods_list.forEach((goods_item)=>{

                            switch(goods_item.type){
                              case "curriculum": {

                                  if (goods_item.res_uuid in best_discount_dict['cur']){

                                      let cur_promotes = best_discount_dict['cur'][goods_item.res_uuid];

                                    if (cur_promotes.discount_type && cur_promotes.discount_uuid) {

                                        goods_item.promotes = [{
                                          type: cur_promotes.discount_type,
                                          uuid: cur_promotes.discount_uuid
                                        }];

                                        goods_item.discount_desc = cur_promotes.max_discount_desc;
                                        goods_item.discount_amount = parseFloat(cur_promotes.max_discount_amount.toFixed(2));
                                        goods_item.amount = parseFloat((goods_item.amount - cur_promotes.max_discount_amount).toFixed(2));

                                        if (cur_promotes.discount_type === 'vip'
                                          && cur_promotes.promotes_item.vip_card.type === 'free') {

                                            goods_item.expired_days = Math.ceil(delta_days_text(cur_promotes.promotes_item.rights_end));

                                        }
                                    }

                                  }

                              } break;
                              case "vip": {
                              } break;
                            }

                        });

                        this.notifyGoodsDiscouontTotal();

                        if (that.discount_amount > 0) {

                          this.$notify({
                            message:`系统已经为您自动选择折扣,优惠${that.discount_amount}元`,
                            type: 'success',
                            offset: 70
                          });

                        }

                    } else {
                      this.$dialog.alert({
                        title: '提示',
                        message: result.error_msg,
                      })
                    }

                    that.best_discount_loading = false;

                  }).catch(err => {
                    this.$dialog.alert({
                      title: '提示',
                      message: result.error_msg,
                    })
                  });
                }

                setTimeout(()=>{
                  that.isShow = true;
                }, 200);


            } else {

                window.location.href = '/mobile/center/order';

//              this.$dialog.alert({
//                title: '提示',
//                message: result.error_msg,
//              }).then(()=>{
//                that.goPath('/mobile/course/list');
//              })

            }

            this.$emit('update:isShowOverlay', false);

          }).catch(err=>{
            this.$dialog.alert({
              title: '提示',
              message: err,
            })

            this.$emit('update:isShowOverlay', false);
          });
      },
      notifyGoodsDiscouontTotal(){
        let total_discount_amount = 0;
        this.order_goods_list.forEach(item => {
          total_discount_amount += item.discount_amount;
        });
        this.discount_amount = parseFloat(total_discount_amount.toFixed(2));
      },
      selectChange(val) {
        this.selectedRows = val;
      },
      clearDiscount() {
        this.discountModal.radio = '';
      },
      showDiscountModal(row){

          this.discountModal.ref_row = toRefs(row);

          if (row.promotes.length > 0){
              let promote_item = row.promotes[0];
              this.discountModal.radio = `${promote_item.type}#${promote_item.uuid}`;
              this.discountModal.noDiscount = false;
          } else {
              this.discountModal.noDiscount = true;
              this.discountModal.radio = '';
          }

          if(row.type == 'curriculum'){
              this.discountModal.tabActiveName = 'able';
              this.loadCurPromotes(row.cur_uuid);
          }

      },
      loadCurPromotes(cur_uuid){

        const that = this;

        this.discountModal.loading = true;
        this.discountModal.res_uuid = cur_uuid;
        this.discountModal.res_type = 'curriculum';

        let query_filter = {
          'goods_type': 'curriculum',
          'goods_uuid': cur_uuid,
          'mode': this.discountModal.tabActiveName,
          'exclude_promotes': this.getOtherSelectedPromotes(),
        };

        listPromotes(query_filter).then(result => {

            if(result.succeed){

              that.discountModal.vip_users = [];
              that.discountModal.coupons_users = [];

              let match_vip = false;
              let match_coupons = false;
              let promotes_uuid = null;

              if(this.discountModal.radio!==''){

                  let split_arr = this.discountModal.radio.split('#')
                  let promotes_type = split_arr[0];
                  promotes_uuid = split_arr[1];

                if (promotes_type === 'vip') {
                    match_vip = true;
                } else if (promotes_type === 'coupons') {
                    match_coupons = true;
                }

              }

              result.vips.forEach(item => {

                console.log('item->', item);

                item.vip_card.single_show = true;

                let filled_item = fmtVIPCardInfo(item.vip_card);
                filled_item.promote_type = 'vip_card';
                filled_item.rights_start_local = db_time_to_local_fmt(item.rights_start);
                filled_item.expired_at = db_time_to_local_fmt(item.rights_end, 'yyyy-MM-dd');
                filled_item.expired_at_origin = item.rights_end;
                filled_item.failed_code = item.failed_code;
                filled_item.disabled_reason = item.failed_reason;
                filled_item.promotes_uuid = item.uuid;
                filled_item.discount_amount = get_goods_discount_amount(this.discountModal.ref_row.price, 'vip', item).discount_amount;

                console.log('vips', item.failed_code , item.failed_reason);

                let delta_conf = expired_delta_days_conf(item.rights_end);
                filled_item.expired_days = delta_conf.delta_days;
                filled_item.expired_text = delta_conf.delta_text;
                filled_item.expired_text_color = delta_conf.text_color;

                that.discountModal.vip_users.push(filled_item);

                if (match_vip && promotes_uuid === filled_item.promotes_uuid){
                    this.discountModal.current_promotes = filled_item;
                }

              });

              result.coupons.forEach(item => {

                item.coupons.single_show = true;

                let filled_item = fmtCouponsInfo(item.coupons);
                filled_item.promote_type = 'coupons';
                filled_item.time_start_local = db_time_to_local_fmt(item.time_start);
                filled_item.expired_at = db_time_to_local_fmt(item.time_end, 'yyyy-MM-dd');
                filled_item.expired_at_origin = item.time_end;
                filled_item.failed_code = item.failed_code;
                filled_item.disabled_reason = item.failed_reason;
                filled_item.discount_amount = get_goods_discount_amount(this.discountModal.ref_row.price, 'coupons', item).discount_amount;

                console.log('coupons', item.failed_code , item.failed_reason);

                filled_item.promotes_uuid = item.uuid;

                let delta_conf = expired_delta_days_conf(item.time_end);
                filled_item.expired_days = delta_conf.delta_days;
                filled_item.expired_text = delta_conf.delta_text;
                filled_item.expired_text_color = delta_conf.text_color;

                that.discountModal.coupons_users.push(filled_item);

                if (match_coupons && promotes_uuid === filled_item.promotes_uuid){
                    this.discountModal.current_promotes = filled_item;
                }

              });

              this.discountModal.visible = true;

            }else{
              this.$dialog.alert({
                title: '提示',
                message: result.error_msg,
              })
            }

            this.discountModal.loading = false;

        }).catch(err => {
          this.$dialog.alert({
            title: '提示',
            message: err
          })
        });
      },
      getOtherSelectedPromotes(){

        let current_coupons_user_uuids = [];
        let current_vip_user_uuids = [];
        let current_promotes = this.discountModal.ref_row.promotes;
        current_promotes.forEach(item => {
          switch (item.type) {
            case "coupons": {
              current_coupons_user_uuids.push(item.uuid);
            }
              break;
            case "vip": {
              current_vip_user_uuids.push(item.uuid);
            }
              break;
          }

        });


        let selected_coupons_user_uuids = [];
        let selected_vip_user_uuids = [];
        this.order_goods_list.forEach(item => {

          let promotes = JSON.parse(JSON.stringify(item.promotes));

          promotes.forEach(item => {

            switch (item.type) {
              case "coupons": {
                if (!current_coupons_user_uuids.includes(item.uuid)) {
                  selected_coupons_user_uuids.push(item.uuid);
                }

              } break;
              case "vip": {
                if (!current_vip_user_uuids.includes(item.uuid)) {
                  selected_vip_user_uuids.push(item.uuid);
                }

              } break;
            }

          });

        });

        return {
          coupons: selected_coupons_user_uuids,
          vips: []
//          vips: selected_vip_user_uuids
        }

      },
      async confirmCurrentPromotes(){

        if (this.discountModal.radio !== '') {

          let promotes = this.discountModal.radio.split('#');

          this.discountModal.ref_row.promotes = [{
            type: promotes[0],
            uuid: promotes[1]
          }];
          console.log('current_promotes', this.discountModal.current_promotes);


          if (this.discountModal.current_promotes) {


            let goods_discount = get_goods_discount_amount(
              this.discountModal.ref_row.price,
              promotes[0],
              this.discountModal.current_promotes);

            this.discountModal.ref_row.discount_amount = parseFloat(goods_discount.discount_amount.toFixed(2));
            this.discountModal.ref_row.amount = parseFloat(goods_discount.goods_amount.toFixed(2));

            let expired_days = null;

            if (this.discountModal.current_promotes.promote_type === 'vip_card'
              && this.discountModal.current_promotes.vip_type === 'free'){
                 expired_days = Math.ceil(delta_days_text(this.discountModal.current_promotes.expired_at_origin));
            }

            this.discountModal.ref_row.expired_days = expired_days;
            this.discountModal.ref_row.discount_desc = goods_discount.discount_desc;

          } else {
            console.log('autoload item ,skipped')
          }


        } else {
            this.discountModal.ref_row.promotes = [];
            this.discountModal.ref_row.discount_amount = 0;
            this.discountModal.ref_row.expired_days = null;
        }

        this.discountModal.visible = false;
        this.$refs.couponsExchangeFrm.resetValidation();

      },
      cancelCurrentPromotes(){
          this.discountModal.visible = false;
          this.$refs.couponsExchangeFrm.resetValidation();
      },
      submitOrder(){

        let post_data = {
            'confirm_key': this.confirm_key,
            'order_goods': [],
            'seller_code': getCookie('promo_code'),
            'order_amount': this.order_amount
        };

        this.order_goods_list.forEach(item => {

          post_data['order_goods'].push({
            type: item.type,
            res_uuid: item.res_uuid,
            promotes: JSON.parse(JSON.stringify(item.promotes))
          });

        });

        this.submit_order_process = true;

        let that = this;
        submitOrder(post_data).then(result => {

          if (result.succeed) {

              let order_info = result.instance.order_info;
              that.goPath(`/mobile/order/pay/${order_info.uuid}`);


              if(result.price_change){
                  showMessage('订单商品价格已经发生改变，系统已经重新为您计算价格')
              }

              that.$emit('update:cartItemCount', result.cart_item_count);

          } else {
              loadingInstance.close();
              this.$dialog.alert({
                title: '提示',
                message: result.error_msg,
              }).then(()=>{
                that.goPath('/mobile/course/list');
              })
          }

          that.submit_order_process = false;

        }).catch(err => {
          loadingInstance.close();
          this.$dialog.alert({
            title: '提示',
            message: err
          })
        });

      },
      goCurDetail(cur_uuid){
        const cur_detail_page = this.$router.resolve({name: 'CourseDetail', params: {uuid: cur_uuid}});
        window.open(cur_detail_page.href, '_blank');
      },
      exchangeCouponsUser(){

        const that = this;

        this.$refs.couponsExchangeFrm.validate().then(() => {

          exchangeCoupons(this.discountModal.codeForm.exchangeCode).then(result => {

            if (result.succeed) {

              that.$notify({
                title: '兑换成功',
                message: '优惠券已放入卡包~',
                type: 'success'
              });

              if (that.discountModal.tabActiveName != 'able') {
                that.discountModal.tabActiveName = 'able';
              }

              if (this.discountModal.ref_row.type == 'curriculum') {
                that.loadCurPromotes(this.discountModal.ref_row.cur_uuid);
              }

            } else {
              that.$notify({
                title: '提示',
                message: result.error_msg,
                type: 'warning'
              });
            }

          }).catch(err => {
            that.$notify({
              title: '提示',
              message: err,
              type: 'warning'
            });
          });

        }).catch((err)=>{
            console.log('error submit::', err);
        });
      },
      notifyPromotesRadioChange(promotes){
          this.discountModal.current_promotes = promotes;
      },
      goPath(path) {
        this.$router.push(path);
      },
    },
    watch: {
      discount_amount(val) {
          this.discount_amount = val;
          this.order_amount = parseFloat((this.total_amount - this.discount_amount).toFixed(2));
      }
    }
  }
</script>

<style lang="scss" scoped>
  .items_wrap {
    padding:10px;
    :deep(.van-cell-group) {
      margin-bottom:10px;
      .van-cell {
        padding:10px;
        .van-cell__title {
          min-width:0;
        }
        .course_item_common {
          .cover {
            margin:0 10px 0 0;
          }
          .content {
            padding-top:20px;
            .info {
              > span {
                margin-right:10px;
              }
            }
          }
        }
        .coupons_select {
          display:flex;
          white-space: nowrap;
          .title {
            margin-right:10px;
          }
          .info {
            font-size:12px;
            color:#999;
          }
        }
        &:after {
          left:10px;
          right:10px;
        }
      }
    }
    .tip {
      padding:5px 0;
      color:#999;
      font-size:12px;
      margin-bottom:5px;
    }
  }
  .sheet_fixed_bottom_common {
    display:flex;
    align-items: center;
    justify-content: flex-end;
    > span {
      margin-left:10px;
      margin-right:15px;
      font-size:32px;
      color:#f51c21;
      font-family: 'font-540';
      > span {
        font-size:18px;
        margin-right:5px;
      }
    }
  }
  .model_wrap {
    margin:-15px;
    padding-top:20px;
    :deep(.code_input) {
      .van-field__label {
        margin-right:5px;
      }
      .van-field__control {
        border: 1px solid #dbdee5;
        border-radius:3px;
        padding-left:5px;
        height:32px;
      }
    }
    .scroll_wrap {
      background:#f7f8fa;
      //height:calc(100vh - 20px - 97px - 98px);
      padding:10px;
      overflow-x:hidden;
      overflow-y:auto;
      .modal_title {
        margin-bottom:10px;
      }
    }
    .discount_item {
      padding:10px;
      border-radius:3px;
      border:1px solid #e5e7ec;
      background:#fff;
      display:flex;
      align-items: center;
      margin-bottom:10px;
      .radio {
        margin-right:10px;
      }
      .discount {
        flex:1;
        min-width:0;
        .vipcard_item {
          margin-bottom:0;
        }
      }
    }
    .btns {
      padding:10px;
      background:#f7f8fa;
      > button {
        margin-top:10px;
        &:first-child {
          margin-top:0;
        }
      }
    }
  }
</style>

